import BaseDataStore from '@/components/base/store/BaseDataStoreV1'

const BaseConst = {
  version: 1,
  storeName: 'C3001ProjectPartnerRequirement',
  serviceName: 'C3001ProjectPartnerRequirementService',
  storeConst: {
    ACTION: {
      getHint: {
        store: 'M3901Guide/getHint'
      }
    }
  },
  componentDef: {
    form: {
      viewDef: [
        {
          column: 'col-12',
          data: 'project_partner_requirement_title',
          label: '项目合作需求标题'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_desc',
          label: '项目合作需求描述'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_target',
          label: '项目合作需求目标',
          type: 'select',
          props: {
            items: [
              { value: 'ADVISOR', text: '顾问' },
              { value: 'CO_FOUNDER', text: '联合创始人' },
              { value: 'MANUFACTURER', text: '制造商' },
              { value: 'EMPLOYEE', text: '员工' },
              { value: 'VENDOR', text: '供应商' },
              { value: 'PARTNER', text: '合作伙伴' },
              { value: 'OTHER', text: '其他' }
            ]
          }
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_end_datetime',
          label: '项目合作需求截止时间',
          type: 'date'

        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_skills',
          label: '项目合作需求技能',
          type: 'textarea'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_experience',
          label: '项目合作需求经验',
          type: 'textarea'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_experience_years',
          label: '项目合作需求经验年限',
          type: 'number'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_slots',
          label: '项目合作需求名额',
          type: 'number'
        },
        {
          column: 'col-12',
          label: '项目合作需求报酬',
          custom: 'HeaderTitle'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_offer_type',
          // 'SALARY','SHARE','MIX','OTHER'
          label: '类型',
          type: 'select',
          props: {
            items: [
              { value: 'SALARY', text: '薪水' },
              { value: 'SHARE', text: '股份' }
              // ? use 2 only
              // { value: 'MIX', text: '混合' },
              // { value: 'OTHER', text: '其他' }
            ]
          }
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_offer',
          label: '报酬',
          show: (val) => val.project_partner_requirement_offer_type === 'OTHER',
          type: 'textarea'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_offer_amount',
          label: '金额',
          show: (val) => val.project_partner_requirement_offer_type === 'SALARY',
          type: 'number'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_offer_share',
          label: '股份',
          show: (val) => val.project_partner_requirement_offer_type === 'SHARE',
          type: 'number'
        },
        {
          column: 'col-12',
          label: '项目合作需求承诺',
          custom: 'HeaderTitle'
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_commitment_type',
          // 'FULL_TIME','PART_TIME','RESOURCE','FREELANCE','TIME','OTHER'
          label: '类型',
          type: 'select',
          props: {
            items: [
              { value: 'FULL_TIME', text: '全职' },
              { value: 'PART_TIME', text: '兼职' },
              { value: 'RESOURCE', text: '资源' },
              { value: 'FREELANCE', text: '自由职业' },
              { value: 'TIME', text: '时间' },
              { value: 'OTHER', text: '其他' }
            ]
          }
        },
        {
          column: 'col-12',
          data: 'project_partner_requirement_commitment_desc',
          label: '描述',
          show: (val) => val.project_partner_requirement_commitment_type === 'OTHER',
          type: 'textarea'
        }
        // {
        //   column: 'col-12',
        //   data: 'project_partner_requirement_policy',
        //   type: 'ttc_policy',
        //   props: {
        //     policyCode: 'collab.projectPartnerRequirement'
        //   }
        // }
      ]
    }
  }
}
const C3001Const = new BaseDataStore(BaseConst)
export default C3001Const
